export function resolveAppPath(href: string): string {
	return href;
}
